import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import BigModuleHead from '@src/pc/index/components/BigModuleHead';
import Chip from 'Chip';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';

const Wonderful = ({ wonderfulData, wonderfulHead }) => {
    return (
        <div className={styles.wonderful}>
            <Chip id="260481" type="struct" title="精彩瞬间头" content={wonderfulHead}>
                <BigModuleHead />
            </Chip>
            <Chip id="287347" type="recommend" title="精彩瞬间列表">
                <div className={styles.wonderfulBox}>
                    {wonderfulData.slice(0, 1).map((item, index) => {
                        const thumbnail = item?.thumbnails?.image?.[0]?.url || '';

                        return (
                            <div key={index} className={styles.wonderfulPicOneBox}>
                                <a href={item.url} target="_blank" className={styles.wonderfulPicOneLink}>
                                    <img
                                        className={styles.wonderfulPicOne}
                                        src={formatImageWebpAuto(thumbnail, 396, 600)}
                                    />
                                    <div className={styles.wonderfulPicOneTextBox}>
                                        <div className={styles.wonderfulPicOneText}>{item.title}</div>
                                    </div>
                                </a>
                            </div>
                        );
                    })}

                    <div className={styles.wonderfulPicList}>
                        {wonderfulData.slice(1, 5).map((item, index) => {
                            const thumbnail = item?.thumbnails?.image?.[0]?.url || '';

                            return (
                                <a href={item.url} key={index} target="_blank" className={styles.wonderfulPicLink}>
                                    <img
                                        className={styles.wonderfulPic}
                                        src={formatImageWebpAuto(thumbnail, 396, 297)}
                                    />
                                    <div className={styles.wonderfulPicTextBox}>
                                        <div className={styles.wonderfulPicText}>{item.title}</div>
                                    </div>
                                </a>
                            );
                        })}
                    </div>
                </div>
            </Chip>
        </div>
    );
};

Wonderful.propTypes = {
    wonderfulData: PropTypes.array,
    wonderfulHead: PropTypes.object,
};

export default errorBoundary(Wonderful);
